import { navigate } from 'gatsby'
import React from 'react'

const DashboardCard = ({
	className = 'block col-span-3 md:col-span-2 overflow-clip text-left',
	image,
	customContent,
	onClick,
	title = '',
	titleIcon,
	underlineTitle = false,
	underlineOnHover = false,
	text = '',
	link = '',
}) => {
	return (
		<React.Fragment>
			<a 
				href={`${link !== '' ? link : 'javascript:;'}`}
				className={`${className} ${link === '' ? 'pointer-events-none' : 'cursor-pointer'}`}
				aria-label={title}
				onClick={(e) => {
					if(onClick) onClick(e)
					link !== '' && navigate(link)
				}}
			>
				{
					customContent ? (
						customContent
					) : (
						<img className='min-w-[150px] min-h-[150px] w-[230px] h-[150px] lg:w-[300px] lg:h-[280px] object-cover' src={image} alt={title} />
					)
				}
				<div className='py-3 space-y-2'>
					<div className='text-[#3D3D3D] text-sm md:text-md font-medium flex items-center gap-1'>
						<span className={`${underlineTitle && 'underline underline-offset-4'} ${underlineOnHover && 'underline-on-hover'}`}>{title}</span>
						{titleIcon && titleIcon}
					</div>
					<p className='text-[#888888] text-xs'>{text}</p>
				</div>
			</a>
		</React.Fragment>
	)
}

export default DashboardCard